import { Icon } from '@iconify/react'
import { Button } from '@pepper/ui'

import s from './ImportModalFooter.module.css'

type ImportModalFooterProps = {
  okText: string
  disabled: boolean
  loading: boolean
  onBack: () => void
  onCancel: () => void
  onOk?: () => void
}

export const ImportModalFooter: React.FC<ImportModalFooterProps> = ({
  okText,
  onBack,
  onCancel,
  loading,
  disabled,
  onOk,
}) => {
  return (
    <footer className={s.footer}>
      <Button
        type="text"
        icon={<Icon icon="lucide:arrow-left" />}
        onClick={onBack}
      >
        Go back
      </Button>
      <div>
        <Button type="link" htmlType="button" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={disabled}
          onClick={onOk}
        >
          {okText}
        </Button>
      </div>
    </footer>
  )
}
